<template>
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="cardForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="cardForm.phone" placeholder="请输入代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="cardForm.real_name" placeholder="请输入代理真实姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="cardForm.bank_code" placeholder="请输入银行卡号"></el-input>
                </el-form-item>
                <!-- 待确定传值方式 -->
                <!-- <el-form-item>
                    <el-cascader v-model="cardForm.address" clearable placeholder="请选择开户所在地"></el-cascader>
                </el-form-item>-->
                <el-form-item>
                    <el-select size v-model="cardForm.auth_status" clearable placeholder="请选择认证状态">
                        <el-option label="验证通过" value="1"></el-option>
                        <el-option label="验证失败" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="cardForm.start_create_time"
                        type="date"
                        placeholder="请选择申请开始时间"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="cardForm.end_create_time"
                        type="date"
                        placeholder="请选择申请结束时间"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(cardForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <!-- <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-s-promotion" @click>占位</el-button>
            </div>-->
            <el-table :data="cardTable" size="mini" border style="width: 100%" v-loading="loading">
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="my_phone"
                    label="代理账号"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.my_phone | desMobile" placement="top">
                      <p>{{ scope.row.my_phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    label="代理编号"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.agent_no" placement="top">
                      <p>{{ scope.row.agent_no | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 真实姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="nickname"
                    label="真实姓名"
                    min-width="120"
                ></el-table-column>
                <!-- 银行名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_name"
                    label="银行名称"
                    min-width="120"
                ></el-table-column>
                <!-- 银行卡号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="bank_code"
                    label="银行卡号"
                    min-width="200"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.bank_code | desIdCard" placement="top">
                      <p>{{ scope.row.bank_code | desIdCard }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 银行预留手机号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="银行预留手机号"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 开户所在地 -->
                <el-table-column header-align="center" align="center" label="开户所在地" min-width="120">
                    <template slot-scope="scope">{{scope.row.bank_prov+'-'+scope.row.bank_city}}</template>
                </el-table-column>
                <!-- 开户支行 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="branch_bank"
                    label="开户支行"
                    min-width="370"
                ></el-table-column>
                <!-- 联行号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="line_num"
                    label="联行号"
                    min-width="120"
                ></el-table-column>
                <!-- 申请时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="申请时间"
                    min-width="150"
                ></el-table-column>
                <!-- 认证时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="update_time"
                    label="认证时间"
                    min-width="150"
                ></el-table-column>
                <!-- 认证状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="auth_status"
                    label="认证状态"
                    min-width="120"
                    :formatter="formatAuth"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="200"
                >
                    <template slot-scope="scope">
                        <el-popover placement="left" width="400" trigger="click" title="认证详情">
                            <el-input
                                type="textarea"
                                v-model="reason"
                                :disabled="true"
                                style="font-size:12px"
                            ></el-input>
                            <el-button
                                @click="handleInfo(scope.row)"
                                type="text"
                                size="small"
                                slot="reference"
                                v-if="level == 0"
                            >详情</el-button>
                        </el-popover>&nbsp;
                        <template v-if="scope.row.auth_status != 1">
                            <!-- 上送验证 -->
                            <el-popconfirm title="是否手动上送银行卡验证？" @onConfirm="handleSend(scope.row)">
                                <el-button type="text" size="small" slot="reference">上送验证</el-button>
                            </el-popconfirm>&nbsp;
                            <!-- 跳过验证 -->
                            <el-popconfirm title="是否确认跳过银行卡验证？" @onConfirm="handleSkip(scope.row)">
                                <el-button slot="reference" type="text" size="small">跳过验证</el-button>
                            </el-popconfirm>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "UM_cardList",
    data() {
        return {
            level: sessionStorage.getItem('level'),
            reason: '', //拒绝原因
            cardTable: [], //表格
            sendFlag: true, //上送防重复
            skipFlag: true, //跳过防重复
            cardForm: {
                phone: '', //代理账号
                real_name: '',   //代理真实姓名
                bank_code: '', //银行卡号
                bank_prov: '', //省
                bank_city: '', //市
                auth_status: '',   //认证状态 1：通过 0 不通过
                start_create_time: '',    //申请开始时间
                end_create_time: '',    //申请结束时间
                page: 1,
                limit: 10
            },
            cloneData: {},
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 100  //总数
            },
            loading: true,
        }
    },
    mounted() {
        this.cloneData = this._.cloneDeep(this.cardForm);
        this.getData(this.cardForm);
    },
    components: {
        paginations
    },
    methods: {
        onSearch() {
            this.cardForm.page = 1;
            this.page.currentPage = 1;
            // 表单提交
            this.getData(this.cardForm);
        },
        //
        handleInfo(row) { //详情
            if (row.auth_status != 1) {
                this.reason = row.reason;
            } else {
                this.reason = '银行卡验证通过';
            }
        },
        handleSend(row) { //上送验证
            if (this.sendFlag) {
                this.sendFlag = false;
                this.$api.post('user/bank_code', { id: row.id }, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.sendFlag = true;
                        this.getData(this.cardForm);
                    } else {
                        this.sendFlag = true;
                        this.$message.error(res.msg);
                    }
                })
            }
        },
        handleSkip(row) { //跳过验证
            if (this.skipFlag) {
                this.skipFlag = false;
                this.$api.post('user/jump_bank_check', { id: row.id, bank_code: row.bank_code }, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.skipFlag = true;
                        this.getData(this.cardForm);
                    } else {
                        this.skipFlag = true;
                        this.$message.error(res.msg);
                    }
                })
            }
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.cardForm.page = this.page.currentPage;
            this.cardForm.limit = this.page.pageSize;
            this.getData(this.cardForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.cardForm.page = this.page.currentPage;
            this.cardForm.limit = limit;
            this.getData(this.cardForm);
        },
        getData(params) {
            this.$api.post("user/bank_list", params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.cardTable = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        formatAuth(row) {
            let str = '';
            switch (row.auth_status) {
                case 1:
                    str = '验证通过';
                    break;
                default:
                    str = '验证失败'
                    break;
            }
            return str;
        }
    }
};
</script>

<style lang="scss" scope>
.el-input__inner {
    font-size: 12px;
}
.el-form-item {
    margin-bottom: 5px;
}
</style>
